import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SearchService, SearchResponse, SearchResult} from '../service/search.service';
import {environment} from 'src/environments/environment';
import {AuthService} from "../service/auth.service";

@Component({
    selector: 'app-search-results',
    templateUrl: './search-results.component.html',
    styleUrls: ['./search-results.component.css']
})
export class SearchResultsComponent implements OnInit {
    imgurl = environment.imageurl;
    query: string = '';
    serviceSlug: string = '';
    serviceId: number = 0;
    serviceName: string = '';
    results: SearchResult[] = [];
    totalResults: number = 0;
    modulesCount: number = 0;
    currentPage: number = 1;
    totalPages: number = 0;
    perPage: number = 10;
    isLoading: boolean = false;
    errorMessage: string = '';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private searchService: SearchService,
        private authservice: AuthService,
    ) {
    }

    ngOnInit(): void {
        this.authservice.hideshowheader(false);
        this.route.queryParams.subscribe(params => {
            this.query = params['q'] || '';
            this.serviceSlug = params['service_slug'] || '';
            this.currentPage = parseInt(params['page']) || 1;

            if (this.query && this.serviceSlug) {
                this.performSearch();
            }
        });
    }

    performSearch(): void {
        if (!this.query || this.query.length < 2) {
            this.errorMessage = 'Search query must be at least 2 characters';
            return;
        }

        this.isLoading = true;
        this.errorMessage = '';
        const token = localStorage.getItem('auth-token') || '';

        this.searchService.searchContent(token, this.serviceSlug, this.query, this.currentPage, this.perPage)
            .subscribe(
                (response: SearchResponse) => {
                    this.isLoading = false;
                    if (response.status) {
                        this.results = response.results;
                        this.totalResults = response.total_results;
                        this.modulesCount = response.modules_count;
                        this.totalPages = response.total_pages;
                        this.serviceName = response.service_name;
                        this.serviceId = response.service_id;
                    } else {
                        this.errorMessage = response.message || 'Search failed';
                        this.results = [];
                    }
                },
                (error) => {
                    this.isLoading = false;
                    this.errorMessage = 'An error occurred while searching';
                    this.results = [];
                }
            );
    }

    highlightText(text: string): string {
        if (!text || !this.query) {
            return text || '';
        }
        const regex = new RegExp(`(${this.escapeRegex(this.query)})`, 'gi');
        return text.replace(regex, '<strong>$1</strong>');
    }

    escapeRegex(string: string): string {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    goToPage(pageInput: any): void {
        const page = parseInt(pageInput, 10);
        if (isNaN(page) || page < 1 || page > this.totalPages) {
            return;
        }
        this.currentPage = page;
        this.router.navigate(['/search-results'], {
            queryParams: {
                q: this.query,
                service_slug: this.serviceSlug,
                page: page
            }
        });
    }

    getPageNumbers(): (number | string)[] {
        const totalPages = this.totalPages;
        const currentPage = this.currentPage;
        const delta = 1;
        const range: number[] = [];
        const rangeWithDots: (number | string)[] = [];
        let l: number;

        range.push(1);

        if (totalPages <= 1) {
            return [1];
        }

        for (let i = currentPage - delta; i <= currentPage + delta; i++) {
            if (i < totalPages && i > 1) {
                range.push(i);
            }
        }
        range.push(totalPages);

        for (const i of range) {
            if (l) {
                if (i - l === 2) {
                    rangeWithDots.push(l + 1);
                } else if (i - l !== 1) {
                    rangeWithDots.push('...');
                }
            }
            rangeWithDots.push(i);
            l = i;
        }

        return rangeWithDots;
    }

    navigateToResult(result: SearchResult): void {
        if (result.type === 'page' && result.chapter_slug) {
            if (this.serviceId) {
                this.router.navigate([
                    '/Module',
                    this.serviceId,
                    result.module_id,
                    result.cluster_id || 0,
                    result.chapter_slug,
                    result.id,
                    result.module_type
                ]);
            } else {
                this.router.navigate(['/livebook', result.module_slug, result.module_type], {
                    queryParams: {
                        chapter: result.chapter_slug,
                        page_id: result.id
                    }
                });
            }
        }
    }

    getThumbnailUrl(result: SearchResult): string {
        if (result.thumbnail) {
            return this.imgurl + result.thumbnail;
        }
        return ''
        // return './assets/img/placeholder.png';
    }

    getResultPath(result: SearchResult): string {
        const parts: string[] = [];
        if (result.module_name) {
            parts.push(result.module_name);
        }
        if (result.cluster_name) {
            parts.push(result.cluster_name);
        }
        if (result.chapter_name && result.type === 'page') {
            parts.push(result.chapter_name);
        }
        if (result.type === 'page' && result.page_number) {
            parts.push(`Page ${result.page_number}`);
        }
        return parts.join(' / ');
    }
}
